import line from "./line";

const TypeOptions = {
  line,
  bar: line,
  pie: line,
};

export default {
  getOption: (config, datas) => {
    const fnGet = TypeOptions[config.type] || TypeOptions.line;
    return fnGet(config, datas);
  },
};
